<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div class="flex gap-2">
      <button routerLink="add" class="btn btn-secondary">Add</button>
    </div>
    <div>
      <div *ngIf="filteredBills">
        <h1 class="text-xs text-nowrap text-left">
          Showing {{(50 * currentPage) - (filteredBills.length != 50?
          (50
          -filteredBills.length) : 0) }} of {{totalResults }} entries
        </h1>
      </div>
    </div>
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
      <div class="flex gap-2">
        <div class="relative">
          <input type="text" [(ngModel)]="search" (input)="onSearchInput()" required placeholder="Search.." class="pl-8" />
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>
        <div class="min-w-48">
          <input type="text" [(ngModel)]="billDateRange" [owlDateTime]="billDate" [owlDateTimeTrigger]="billDate"
            [selectMode]="'range'" (ngModelChange)="onBillDateChange($event)" placeholder="Bill Date" />
          <owl-date-time [pickerType]="'calendar'" #billDate></owl-date-time>
        </div>
        <div>
          <select class="w-full sm:w-44" [(ngModel)]="selectedCompanyId" (ngModelChange)="onCompanyFilterChange()">
            <option [ngValue]="null">Select Company</option>
            <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.CompanyName | capitalize }}
            </option>
          </select>
        </div>
        <div>
          <select class="w-full sm:w-44" [(ngModel)]="selectedVendorId" (ngModelChange)="onVendorFilterChange()" [disabled]="!selectedCompanyId">
            <option [ngValue]="null">Select Vendor</option>
            <option *ngFor="let vendor of vendors" [ngValue]="vendor.id">{{ vendor.DisplayName | capitalize }}
            </option>
          </select>
        </div>
        <div>
          <select class="w-full sm:w-44" [(ngModel)]="selectedPaymentStatus" (ngModelChange)="onPaymentStatusFilterChange()">
            <option value="">All Payments</option>
            <option value="Unpaid">Unpaid</option>
            <option value="Partially Paid">Partially Paid</option>
            <option value="Paid">Paid</option>
            <option value="Due Today">Due Today</option>
            <option value="Overdue">Overdue</option>
            <option value="Upcoming">Upcoming</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <h2><label class="font-bold" for="">Amount</label></h2>
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <div *ngFor="let card of amountStatCards"
      class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">${{ (paymentStats[card.key] || 0) | number:'1.2-2' }}</div>
        </dd>
      </dl>
    </div>
  </div>

  <h2><label class="font-bold" for="">Bills</label></h2>
  <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4">
    <div *ngFor="let card of paymentStatCards"
      class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">{{ card.label }}</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">{{ paymentStats[card.key] || 0 }}</div>
        </dd>
      </dl>
    </div>
  </div>


  <div
    class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    #
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Actions
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Date
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Due Date
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Bill No.
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference
                  </th>

                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    QB ID
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Vendor</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Amount
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Paid
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Remaining
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Payment
                  </th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Status</th>


                </tr>
              </thead>
              <tbody>

                <tr
                  *ngFor="let bill of (filteredBills | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i=index"
                  class="hover:bg-gray-950/5 dark:hover:bg-white/10">

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{i+1}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">

                    <div class="flex gap-2 items-center flex-nowrap">

                      <div class="cursor-pointer hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400" (click)="openDetailModal(bill)">
                        <svg class="size-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path class="ng-tns-c14-5" d="M12 15a3 3 0 100-6 3 3 0 000 6z">
                          </path>
                          <path class="ng-tns-c14-5" clip-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                            fill-rule="evenodd">
                          </path>
                        </svg>
                      </div>

                      <button routerLink="{{bill.id}}/edit"
                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="size-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                      </button>

                      <div class="inline-flex relative">
                        <a href="javascript:void(0)" (click)="showActionButtons(bill.id)"
                          class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                          </svg>
                        </a>

                        <div (outsideClick)="closeActionMenu($event)" outside-click
                          *ngIf="selectedDropdownId === bill.id && toggleActionButtons"
                          class="action-menu"
                          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                          <app-action-dropdown-buttons class="divide-y divide-zinc-950/10 dark:divide-white/10"
                            [source]="'bill'"
                            [bill]="bill"
                            [canPay]="getPaymentStatus(bill) !== 'Paid' && !!bill.Id"
                            (payBill)="openPayBill(bill.id)"
                            (deleteBill)="onDeleteBill(bill.company.id,bill.id)"
                            (sendEmai)="onSendEmail(bill.company.id, bill.id)"
                            (pullFrom)="onSyncBill(bill, 'pull')"
                            (pushTo)="onSyncBill(bill, 'push')"></app-action-dropdown-buttons>
                        </div>
                      </div>
                    </div>

                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{((bill.TxnDate || bill.createdAt) | date: 'MM/DD/YYYY') || 'N/A'}}
                  </td>
                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{(bill.DueDate | date: 'MM/DD/YYYY') || 'N/A'}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{bill.DocNumber || 'N/A'}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                    {{bill.company?.CompanyName || 'N/A'}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 max-w-[200px] overflow-hidden">
                    <div class="flex flex-col gap-0.5 leading-tight">
                      <span class="block max-w-[200px] truncate" [title]="bill.reference?.name || ''">
                        {{ bill.reference?.name || 'N/A'}}
                      </span>

                      <span *ngIf="bill.reference && bill.reference.id"
                        class="reference-id">
                        {{ (bill.reference?.id).slice(0, 8) }}
                      </span>
                    </div>
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{bill.Id ? bill.Id : 'N/A'}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{bill.VendorRef?.name || 'N/A'}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{bill.TotalAmt}}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ getAmountPaid(bill) }}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    {{ getRemainingBalance(bill) }}
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span
                      [ngClass]="getPaymentStatusClass(getPaymentStatus(bill))">{{ getPaymentStatus(bill) }}</span>
                  </td>

                  <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    <span [ngClass]="bill.status == 'created' ? 'badge-primary' : 'badge-success'">{{bill.status |
                      capitalize}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end">
      <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
  </div>
</section>

<app-bill-detail-modal *ngIf="billDetail" [billDetail]="billDetail"
  (closeModal)="billDetail = null"
  (updated)="getAllBills(currentPage)"></app-bill-detail-modal>
